<template>
  <div :class="[`view-44`, className || ``]">
    <img
      class="vector-60"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-26.svg"
      alt="Vector"
    />
    <img
      class="vector-61"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-27.svg"
      alt="Vector"
    />
    <img
      class="vector-62"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-28.svg"
      alt="Vector"
    />
    <img
      class="vector-63"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-29.svg"
      alt="Vector"
    />
    <img
      class="vector-64"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-30.svg"
      alt="Vector"
    />
  </div>
</template>

<script>
export default {
  name: "View5",
  props: ["className"],
};
</script>

<style>
.view-44 {
  height: 14.77%;
  left: 0;
  position: absolute;
  top: 48.99%;
  width: 94.81%;
}

.vector-60 {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 15.62%;
}

.vector-61 {
  height: 100%;
  left: 21.09%;
  position: absolute;
  top: 0;
  width: 15.62%;
}

.vector-62 {
  height: 100%;
  left: 42.19%;
  position: absolute;
  top: 0;
  width: 15.62%;
}

.vector-63 {
  height: 100%;
  left: 63.28%;
  position: absolute;
  top: 0;
  width: 15.62%;
}

.vector-64 {
  height: 104.55%;
  left: 83.98%;
  position: absolute;
  top: -2.27%;
  width: 16.41%;
}

.view-44.view-35,
.view-44.view-46,
.view-44.view-48,
.view-44.view-36,
.view-44.view-37,
.view-44.view-38,
.view-44.view-39,
.view-44.view-40,
.view-44.view-41,
.view-44.view-42,
.view-44.view-43 {
  height: 88%;
  top: 0;
  width: 47.94%;
}

.view-44.view-45,
.view-44.view-49 {
  width: 96.97%;
}
</style>
